import { ExprNode } from '@mode-switch/express';
import { PipelineError } from '../PipelineError';
export var CallNames;
(function (CallNames) {
    function make(catalog) {
        return (pipeline, node) => {
            switch (node.type) {
                case "CallExpression":
                    return vCall(pipeline, catalog, node);
                default:
                    return pipeline;
            }
        };
    }
    CallNames.make = make;
    function vCall(pipeline, catalog, node) {
        const callName = ExprNode.CallName.make(node.callee);
        if (catalog.isSupportedCallName(callName)) {
            return pipeline;
        }
        else {
            return new PipelineError.InternalError(`${callName.name} is not supported.`);
        }
    }
})(CallNames || (CallNames = {}));
